import React, { Component } from "react";
import Dropzone from "react-dropzone";
import { connect } from "react-redux";
import _ from "i18n";
import { setTimeSheetAttachment } from "Actions";
import { CloudUploadIcon } from "../Icons";

class DocumentUploader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      processing: false
    };
  }

  handleDrop = acceptedFiles => {
    if (acceptedFiles.length === 0) return;
    this.props.dispatch(setTimeSheetAttachment(acceptedFiles[0]));
  };

  saveAttachment = () => {
    let { attachment, processing } = this.state;
    if (!attachment || processing) {
      return;
    }
    this.setState({ processing: true });
  };

  render() {
    const { attachment, handleDrop, acceptedFiles } = this.props;
    return (
      <div className="attachments-container">
        <Dropzone
          className="attachments-dropzone row medium-10"
          ref={node => {
            this.dropzone = node;
          }}
          onDrop={handleDrop ? handleDrop : this.handleDrop}
          multiple={false}
          accept={
            acceptedFiles
              ? acceptedFiles
              : ".xls,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          }
        >
          <div>
            <span className="icon_upload">
              <CloudUploadIcon />
            </span>
            {attachment ? (
              <div>
                <p>
                  <span className="icon icon-paper-clip" /> {attachment.name}
                </p>
              </div>
            ) : (
              <p>
                <span
                  className="drag_message"
                  dangerouslySetInnerHTML={{
                    __html: _("dragMessage")
                  }}
                />
              </p>
            )}
          </div>
        </Dropzone>
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({});

export default connect(mapStateToProps)(DocumentUploader);



// WEBPACK FOOTER //
// ./src/components/Common/DocumentUploader/DocumentUploader.js